// MessageId.jsx
import React from 'react';

import MongoObjectIdMatcher from '../component/MongoObjectIdMatcher.jsx';
import UniversalComponent from '../component/UniversalComponent.jsx';
import { reactRouterNoindexLoader } from '../resource/reactRouterNoindexLoader.js';

export const loader = reactRouterNoindexLoader;

const MessageIdRoute = () => {
  return (
    <MongoObjectIdMatcher paramKeys={['messageId']}>
      <UniversalComponent
        filename="Page_StoryDetail"
        shouldLoop={true}
        importer={/* #__LOADABLE__ */ () => import('../page/StoryDetail.jsx')}
      />
    </MongoObjectIdMatcher>
  );
};

export default MessageIdRoute;
